const Region = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "search": "Search",

    // PAGE HEADER
    "region": "Region",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",

}

export default Region;